import * as types from './mutation-types'
import {createFormData} from "@/mixins/Helper.vue";
import {LOAD_DISCOUNT_TYPES} from "./mutation-types";
export const loadPromotions = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/promotions').then((response) => {
            commit(types.LOAD_PROMOTIONS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const createPromotion = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/promotion', data).then((response) => {
            commit(types.ADD_PROMOTION, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const getPromotion = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('show/promotion/' + id ).then((response) => {
            commit(types.SET_CURRENT_PROMOTION, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updatePromotionStatus = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/promotion/' + id + '/status').then((response) => {
            // commit(types.UPDATE_PROMOTION_STATUS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updatePromotion = ({ commit, dispatch, state }, {id, data}) => {
    return new Promise((resolve, reject) => {
        console.log(data,'edz')

        window.axios.post('update/promotion/' + id, data).then((response) => {
            commit(types.UPDATE_PROMOTION, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const sendPromotionNotify = ({ commit }, { id, type, title = null, message = null }) => {
    return window.axios.post(`send/promotions/notify/${id}`, { type, title, message })
        .then(response => {
            if (response.data?.notification) {
                commit(types.APPEND_PROMOTION_NOTIFICATION, response.data.notification)
            }
            return response
        })
}



export const deletePromotion = ({ commit, dispatch, state }, promotion) => {
    let route = `delete/promotion/${promotion}`
    return new Promise((resolve, reject) => {
        window.axios.delete(route).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const loadAppliesEnum = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('promotion/apply/list').then((response) => {
            commit(types.LOAD_APPLIES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const loadDiscountType =  ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('promotion/type/list').then((response) => {
            commit(types.LOAD_DISCOUNT_TYPES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

